import { Modal } from "react-bootstrap";
import React, { useContext, useState, useEffect } from "react";
import "../../../../Admin/Tabels/Tabels.css";
import { Context } from "../../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col, Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import ModalSave from "../../../../common/ModalSave";
import { CancelButton } from "../../../../common/Button";
import AddedLottieModal from "../../../commonLottie/AddedLottieModal";

library.add(fas);

const EditModal = (props) => {
  const { postData, getData } = useContext(Context);
  const [showLottie, setShowLottie] = useState({ show: false, msg: "", success: false });

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setError,
    clearErrors,
    reset,
  } = useForm();

  useEffect(() => {
    const GetEditData = async () => {
      const response = await getData(`/hrms-masters/prefix/1`);
      reset(response?.data);
    };
    GetEditData()
  }, []);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);

      const response = await postData(`/hrms-masters/prefix/1`, sendData);
    

      if (response?.success) {
        setShowLottie({ show: true, msg: response?.message, success: response?.success });
      } else {
        setShowLottie({ show: true, msg: response?.message, success: response?.success });
      }
      setTimeout(() => {
        setShowLottie({ show: false, msg: "", success: false });
        props.handleClose()
      }, 3000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section className="modal-common-class-hrms">
      <Modal
        show={props.show}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="add-modal"
        onHide={props.handleClose}
      >
        <Modal.Body>
          <div className="text-center">
            <h4 className="modal-title-common">Edit Prefix</h4>
          </div>
          <Container>
            <Row>
              <Col md={12}>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col lg={8} md={10} className="mx-auto Add-content">
                      <div className="main-form-section mt-5">
                        <Form.Label>Prefix</Form.Label>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <InputGroup>
                            <Form.Control
                              type="text"
                              name="name"
                              placeholder="Prefix"
                              maxLength={3}
                              minLength={3}
                              className={classNames("", {
                                "is-invalid": errors?.name,
                              })}
                              {...register("name", {
                                required: "Prefix is required",
                                pattern: {
                                  value: /^[A-Z]{3}$/, // Regex to allow only uppercase letters
                                  message: "must only contain uppercase letters", // Custom error message
                                },

                              })}
                              onKeyDown={(e) => {
                                const currentValue = e.target.value;

                                // Check if the length is already 3 (after 3 characters are entered)
                                if (currentValue.length >= 3) {
                                  // Trigger manual error when trying to type more than 3 characters
                                  setError("name", {
                                    type: "manual", // Error type is manual
                                    message: "Prefix cannot exceed 3 characters", // Error message
                                  });

                                  // Prevent typing more than 3 characters
                                  if (!["Backspace", "Tab", "Enter", "Escape"].includes(e.key)) {
                                    e.preventDefault();
                                  }
                                } else {
                                  // Clear the error message if there's space for more characters
                                  // Reset the error
                                  clearErrors("name");
                                }
                                // Allow: backspace, tab, enter, escape, and space
                                if (
                                  e.key === "Backspace" ||
                                  e.key === "Tab" ||
                                  e.key === "Enter" ||
                                  e.key === "Escape" ||
                                  /^[A-Za-z]$/.test(e.key)
                                ) {
                                  return;
                                }
                                e.preventDefault();
                              }}
                              onChange={(e) => {
                                e.target.value = e.target.value.toUpperCase(); // Convert input to uppercase
                              }}
                            />
                          </InputGroup>

                          {errors.name && (
                            <span className="text-danger">
                              {errors.name.message}
                            </span>
                          )}
                        </Form.Group>
                      </div>
                      <div className="d-flex justify-content-center mt-5 pb-3">
                        <CancelButton
                          name="cancel"
                          handleClose={props.handleClose}
                        />
                        <button type="submit" className="save-button">
                          Save
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
      <AddedLottieModal
        pageTitle="Designation"
        message={showLottie.msg}
        show={showLottie.show}
        success={showLottie.success}
        onHide={() => setShowLottie({ show: false, msg: "", success: false })}
      />
    </section>
  );
};

export default EditModal;
